var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { childrenExist, createShorthandFactory, UIComponent, commonPropTypes, } from '../../lib';
/**
 * A Text component formats occurrences of text consistently.
 * @accessibility
 * Text is how people read the content on your website.
 * Ensure that a contrast ratio of at least 4.5:1 exists between text and the background behind the text.
 *
 * To ensure that RTL mode will be properly handled for provided 'content' value, ensure that either:
 * - 'content' is provided as plain string (then dir="auto" attribute will be applied automatically)
 * - for other 'content' value types (i.e. that use elements inside) ensure that dir="auto" attribute is applied for all places in content where necessary
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Text.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest;
        var _b = this.props, children = _b.children, content = _b.content;
        var hasChildren = childrenExist(children);
        var maybeDirAuto = !hasChildren && typeof content === 'string' ? { dir: 'auto' } : null;
        return (React.createElement(ElementType, __assign({ className: classes.root }, maybeDirAuto, rest), hasChildren ? children : content));
    };
    Text.className = 'ui-text';
    Text.displayName = 'Text';
    Text.propTypes = __assign({}, commonPropTypes.createCommon({ color: true }), { atMention: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['me'])]), disabled: PropTypes.bool, error: PropTypes.bool, important: PropTypes.bool, size: PropTypes.oneOf(['smallest', 'smaller', 'small', 'medium', 'large', 'larger', 'largest']), weight: PropTypes.oneOf(['light', 'semilight', 'regular', 'semibold', 'bold']), success: PropTypes.bool, temporary: PropTypes.bool, timestamp: PropTypes.bool, truncated: PropTypes.bool });
    Text.defaultProps = {
        as: 'span',
    };
    return Text;
}(UIComponent));
Text.create = createShorthandFactory(Text, 'content');
export default Text;
